<template>
  <div class="repair-container">
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <el-form :model="queryParams" :inline="true" class="search-form">
        <el-form-item label="联系人：">
          <el-input
            v-model="queryParams.contactName"
            placeholder="请输入联系人"
            clearable
            style="width: 140px"
          />
        </el-form-item>
        
        <el-form-item label="位置：">
          <el-input
            v-model="queryParams.location"
            placeholder="请输入位置"
            clearable
            style="width: 160px"
          />
        </el-form-item>
        
        <el-form-item label="状态：">
          <el-select 
            v-model="queryParams.status" 
            placeholder="请选择状态"
            clearable
            style="width: 140px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option 
              v-for="status in statusOptions" 
              :key="status.value" 
              :label="status.label" 
              :value="status.value"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
          <el-button 
            type="success" 
            icon="el-icon-plus" 
            @click="handleAdd"
            class="btn-add"
          >
            新建维修
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-title">
          <i class="el-icon-setting"></i>
          维修服务管理
        </div>
        <div class="table-actions">
          <el-input
            v-model="quickSearch"
            placeholder="快速搜索..."
            prefix-icon="el-icon-search"
            style="width: 200px; margin-right: 10px;"
            size="small"
            clearable
            @input="handleQuickSearch"
          />
        </div>
      </div>
      
      <el-table
        ref="repairTable"
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
        >
        <!-- 序号列 -->
        <el-table-column 
          label="序号" 
          width="70"
          align="center"
        >
          <template slot-scope="scope">
            <span class="serial-number">
              {{ (pageIndex - 1) * pageSize + scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>
        
        <!-- 状态 -->
        <el-table-column 
          prop="status" 
          label="状态" 
          width="100"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag 
              :type="getStatusTagType(row.status)"
              size="small"
            >
              {{ getStatusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        
        <!-- 联系人 -->
        <el-table-column 
          prop="contactName" 
          label="联系人" 
          width="120"
          align="center"
        />
        
        <!-- 联系电话 -->
        <el-table-column 
          prop="contactPhone" 
          label="联系电话" 
          width="130"
          align="center"
        />
        
        <!-- 位置 -->
        <el-table-column 
          prop="location" 
          label="位置" 
          width="150"
          show-overflow-tooltip
        />
        
        <!-- 问题描述 -->
        <el-table-column 
          prop="description" 
          label="问题描述" 
          min-width="200"
          show-overflow-tooltip
        />
        
        <!-- 创建时间 -->
        <el-table-column 
          prop="createTime" 
          label="报修时间" 
          width="160"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ formatDate(row.createTime) }}</span>
          </template>
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column 
          prop="updateTime" 
          label="更新时间" 
          width="160"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ formatDate(row.updateTime) }}</span>
          </template>
        </el-table-column>
        
        <!-- 操作列 -->
        <el-table-column 
          label="操作" 
          width="280" 
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="action-buttons">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-view"
                @click="handleView(row)"
              >
                查看
              </el-button>
              
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(row)"
                :disabled="row.status === 4 || row.status === 5"
              >
                编辑
              </el-button>
              
              <!-- 状态操作按钮组 -->
              <el-button-group v-if="row.status < 4" style="margin-left: 5px;">
                <el-button
                  v-if="row.status === 1"
                  type="info"
                  size="mini"
                  @click="handleDispatch(row)"
                >
                  派单
                </el-button>
                
                <el-button
                  v-if="row.status === 2"
                  type="info"
                  size="mini"
                  @click="handleStartRepair(row)"
                >
                  开始维修
                </el-button>
                
                <el-button
                  v-if="row.status === 3"
                  type="success"
                  size="mini"
                  @click="handleComplete(row)"
                >
                  完成
                </el-button>
                
                <el-button
                  type="danger"
                  size="mini"
                  @click="handleCancel(row)"
                >
                  取消
                </el-button>
              </el-button-group>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="footer-area">
        <el-pagination
          v-if="total > 0"
          class="pagination-container"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <PropertyRepairDialog
      :visible="dialogVisible"
      :form-data="currentFormData"
      :is-edit="isEditMode"
      @close="handleDialogClose"
      @save="handleSave"
    />
  </div>
</template>

<script>
import propertyRepairApi from '../api/propertyRepair.js'
import PropertyRepairDialog from '../components/PropertyRepairDialog.vue'

export default {
  name: "PropertyRepairList",
  components: {
    PropertyRepairDialog
  },
  
  data() {
    return {
      // 加载状态
      loading: false,
      
      // 数据
      originalData: [],
      tableData: [],
      filteredData: [],
      total: 0,
      
      // 快速搜索
      quickSearch: '',
      
      // 分页参数
      pageIndex: 1,
      pageSize: 10,
      
      // 查询参数
      queryParams: {
        contactName: '',
        location: '',
        status: ''
      },
      
      // 状态选项
      statusOptions: [
        { label: '待处理', value: 1 },
        { label: '派单中', value: 2 },
        { label: '维修中', value: 3 },
        { label: '已完成', value: 4 },
        { label: '已取消', value: 5 }
      ],
      
      // 对话框相关
      dialogVisible: false,
      isEditMode: false,
      currentFormData: {},
      
      // 表格高度
      tableHeight: 500,
      
      // 搜索防抖
      searchTimer: null
    }
  },
  
  created() {
    this.getProfile();
  },
  
  methods: {
    /**
     * 获取维修列表
     */
    getProfile() {
      var self = this;
      this.loading = true;
      
      propertyRepairApi.getAllPropertyRepairs().then(function(response) {
        if (response && response.data && response.data.flag === true) {
          self.originalData = response.data.data || [];
          self.filteredData = response.data.data || [];
          self.total = self.originalData.length;
          
          self.applyFilter();
          console.log('已加载 ' + self.originalData.length + ' 条维修数据');
        } else {
          self.$message.error('获取维修列表失败');
          self.originalData = [];
          self.filteredData = [];
          self.total = 0;
          self.tableData = [];
        }
      }).catch(function(error) {
        console.error('获取维修列表失败:', error);
        self.$message.error('加载失败，请检查网络连接');
        self.originalData = [];
        self.filteredData = [];
        self.total = 0;
        self.tableData = [];
      }).finally(function() {
        self.loading = false;
      });
    },
    
    /**
     * 应用分页
     */
    applyPagination() {
      var start = (this.pageIndex - 1) * this.pageSize;
      var end = start + this.pageSize;
      this.tableData = this.filteredData.slice(start, end);
    },
    
    /**
     * 应用筛选
     */
    applyFilter() {
      var filtered = this.originalData.slice();
      
      // 应用查询条件
      if (this.queryParams.contactName && this.queryParams.contactName.trim()) {
        var contactFilter = this.queryParams.contactName.trim();
        filtered = filtered.filter(function(item) {
          return item.contactName && item.contactName.includes(contactFilter);
        });
      }
      
      if (this.queryParams.location && this.queryParams.location.trim()) {
        var locationFilter = this.queryParams.location.trim();
        filtered = filtered.filter(function(item) {
          return item.location && item.location.includes(locationFilter);
        });
      }
      
      if (this.queryParams.status !== '') {
        var statusFilter = Number(this.queryParams.status);
        filtered = filtered.filter(function(item) {
          return item.status === statusFilter;
        });
      }
      
      // 快速搜索
      if (this.quickSearch && this.quickSearch.trim()) {
        var search = this.quickSearch.trim().toLowerCase();
        filtered = filtered.filter(function(item) {
          return (
            (item.contactName && item.contactName.toLowerCase().includes(search)) ||
            (item.contactPhone && item.contactPhone.toLowerCase().includes(search)) ||
            (item.location && item.location.toLowerCase().includes(search)) ||
            (item.description && item.description.toLowerCase().includes(search))
          );
        });
      }
      
      // 按创建时间倒序排序
      filtered.sort(function(a, b) {
        return new Date(b.createTime) - new Date(a.createTime);
      });
      
      this.filteredData = filtered;
      this.total = filtered.length;
      this.pageIndex = 1;
      this.applyPagination();
    },
    
    /**
     * 处理搜索
     */
    handleSearch() {
      this.applyFilter();
    },
    
    /**
     * 处理快速搜索（防抖）
     */
    handleQuickSearch() {
      var self = this;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(function() {
        self.applyFilter();
      }, 300);
    },
    
    /**
     * 处理重置
     */
    handleReset() {
      this.queryParams = {
        contactName: '',
        location: '',
        status: ''
      };
      this.quickSearch = '';
      this.pageIndex = 1;
      this.applyFilter();
    },
    
    /**
     * 处理添加
     */
    handleAdd() {
      this.currentFormData = {
        contactName: '',
        contactPhone: '',
        location: '',
        description: '',
        status: 1
      };
      this.isEditMode = false;
      this.dialogVisible = true;
    },
    
    /**
     * 处理编辑
     */
    handleEdit(row) {
      this.currentFormData = {
        id: row.id,
        contactName: row.contactName,
        contactPhone: row.contactPhone,
        location: row.location,
        description: row.description,
        status: row.status
      };
      this.isEditMode = true;
      this.dialogVisible = true;
    },
    
    /**
     * 处理查看
     */
    handleView(row) {
      this.$alert(
        `<div style="line-height: 1.8;">
          <p><strong>状态：</strong><span style="color: ${this.getStatusColor(row.status)}">${this.getStatusLabel(row.status)}</span></p>
          <p><strong>联系人：</strong>${row.contactName || '-'}</p>
          <p><strong>联系电话：</strong>${row.contactPhone || '-'}</p>
          <p><strong>位置：</strong>${row.location || '-'}</p>
          <p><strong>问题描述：</strong>${row.description || '-'}</p>
          <p><strong>报修时间：</strong>${this.formatDate(row.createTime)}</p>
          <p><strong>更新时间：</strong>${this.formatDate(row.updateTime)}</p>
        </div>`,
        '维修详情',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '关闭'
        }
      );
    },
    
    /**
     * 处理派单
     */
    handleDispatch(row) {
      var self = this;
      this.$confirm('确定要派单吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        return propertyRepairApi.updatePropertyRepair({
          id: row.id,
          status: 2  // 设置为派单中状态
        });
      }).then(function(response) {
        if (response.data && response.data.flag === true) {
          self.$message.success('派单成功');
          self.getProfile();
        } else {
          self.$message.error('派单失败');
        }
      }).catch(function(error) {
        if (error && error !== 'cancel') {
          console.error('派单失败:', error);
          self.$message.error('派单失败，请重试');
        }
      });
    },
    
    /**
     * 处理开始维修
     */
    handleStartRepair(row) {
      var self = this;
      this.$confirm('确定要开始维修吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        return propertyRepairApi.updatePropertyRepair({
          id: row.id,
          status: 3  // 设置为维修中状态
        });
      }).then(function(response) {
        if (response.data && response.data.flag === true) {
          self.$message.success('已开始维修');
          self.getProfile();
        } else {
          self.$message.error('操作失败');
        }
      }).catch(function(error) {
        if (error && error !== 'cancel') {
          console.error('操作失败:', error);
          self.$message.error('操作失败，请重试');
        }
      });
    },
    
    /**
     * 处理完成
     */
    handleComplete(row) {
      var self = this;
      this.$confirm('确定要标记为"已完成"吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        return propertyRepairApi.updatePropertyRepair({
          id: row.id,
          status: 4  // 设置为已完成状态
        });
      }).then(function(response) {
        if (response.data && response.data.flag === true) {
          self.$message.success('操作成功');
          self.getProfile();
        } else {
          self.$message.error('操作失败');
        }
      }).catch(function(error) {
        if (error && error !== 'cancel') {
          console.error('操作失败:', error);
          self.$message.error('操作失败，请重试');
        }
      });
    },
    
    /**
     * 处理取消
     */
    handleCancel(row) {
      var self = this;
      this.$confirm('确定要取消该维修申请吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        return propertyRepairApi.updatePropertyRepair({
          id: row.id,
          status: 5  // 设置为已取消状态
        });
      }).then(function(response) {
        if (response.data && response.data.flag === true) {
          self.$message.success('取消成功');
          self.getProfile();
        } else {
          self.$message.error('取消失败');
        }
      }).catch(function(error) {
        if (error && error !== 'cancel') {
          console.error('取消失败:', error);
          self.$message.error('取消失败，请重试');
        }
      });
    },
    
    /**
     * 处理删除
     */
    handleDelete(row) {
      var location = row.location || '该维修记录';
      
      var self = this;
      this.$confirm('确定要删除"' + location + '"吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        return propertyRepairApi.deleteRepair(row.id);
      }).then(function(response) {
        if (response.data && response.data.flag === true) {
          self.$message.success('删除成功');
          self.getProfile();
        } else {
          self.$message.error('删除失败');
        }
      }).catch(function(error) {
        if (error && error !== 'cancel') {
          console.error('删除失败:', error);
          self.$message.error('删除失败，请重试');
        }
      });
    },
    
    /**
     * 处理分页大小变化
     */
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.applyPagination();
    },
    
    /**
     * 处理页码变化
     */
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.applyPagination();
    },
    
    /**
     * 处理对话框关闭
     */
    handleDialogClose() {
      this.dialogVisible = false;
      this.currentFormData = {};
    },
    
    /**
     * 处理保存
     */
    handleSave(formData) {
      var self = this;
      var promise;
      
      if (this.isEditMode) {
        promise = propertyRepairApi.updatePropertyRepair(formData);
      } else {
        promise = propertyRepairApi.addPropertyRepair(formData);
      }
      
      promise.then(function(response) {
        if (response && response.data && response.data.flag === true) {
          self.$message.success(self.isEditMode ? '更新成功' : '新增成功');
          self.dialogVisible = false;
          self.currentFormData = {};
          self.getProfile();
        } else {
          var message = (response && response.data && response.data.message) || '保存失败';
          self.$message.error(message);
        }
      }).catch(function(error) {
        console.error('保存失败:', error);
        self.$message.error('保存失败，请重试');
      });
    },
    
    /**
     * 格式化日期
     */
    formatDate(dateStr) {
      if (!dateStr) return '-';
      try {
        var date = new Date(dateStr);
        return date.toLocaleString('zh-CN');
      } catch (e) {
        return dateStr;
      }
    },
    
    /**
     * 获取状态标签
     */
    getStatusLabel(statusCode) {
      const statusMap = {
        1: '待处理',
        2: '派单中',
        3: '维修中',
        4: '已完成',
        5: '已取消'
      };
      return statusMap[statusCode] || '未知状态';
    },
    
    /**
     * 获取状态标签样式
     */
    getStatusTagType(statusCode) {
      const map = {
        1: 'warning',    // 待处理 - 黄色
        2: 'primary',    // 派单中 - 蓝色
        3: 'info',       // 维修中 - 青色
        4: 'success',    // 已完成 - 绿色
        5: 'danger'      // 已取消 - 红色
      };
      return map[statusCode] || 'info';
    },
    
    /**
     * 获取状态颜色
     */
    getStatusColor(statusCode) {
      const map = {
        1: '#e6a23c',    // 待处理 - 黄色
        2: '#409eff',    // 派单中 - 蓝色
        3: '#909399',    // 维修中 - 灰色
        4: '#67c23a',    // 已完成 - 绿色
        5: '#f56c6c'     // 已取消 - 红色
      };
      return map[statusCode] || '#909399';
    }
  }
}
</script>

<style scoped>
.repair-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(90vh - 84px);
}

.search-card {
  margin-bottom: 20px;
  border-radius: 8px;
  border: none;
}

.search-form {
  margin-bottom: -10px;
}

.btn-add {
  background-color: #67c23a;
  border-color: #67c23a;
  color: white;
}

.table-card {
  border-radius: 8px;
  overflow: hidden;
  border: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 8px;
}

.table-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}

.table-title i {
  margin-right: 8px;
  color: #409EFF;
  font-size: 20px;
}

.footer-area {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.pagination-container {
  text-align: right;
}

.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.serial-number {
  color: #909399;
  font-weight: 500;
}

.el-table {
  font-size: 14px;
}

.el-table th {
  background-color: #f5f7fa !important;
  font-weight: 600;
}

.el-table td {
  padding: 12px 0;
}

/* 状态按钮组样式 */
.el-button-group {
  margin-left: 5px;
}

.el-button-group .el-button {
  border-radius: 3px;
  margin: 0 2px;
}
</style>